import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { recalculateExpenses } from "../../salaries/payslips/payslipsSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import useMessage from "../../../hooks/useMessage";
import { SpinnerButton } from "../../../common/components/functional/spinnerButton/SpinnerButton";

type Props = {
  talentId: string | undefined;
};

export const CalculateExpensesTool = ({ talentId }: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { sendMessage } = useMessage();

  const [calculateExpensesFrom, setCalculateExpensesFrom] =
    useState<Date | null>(null);
  const [calculateAccumulationsOnly, setCalculateAccumulationsOnly] =
    useState<boolean>(false);

  const [areExpensesCalculated, setAreExpensesCalculated] =
    useState<boolean>(false);

  const handleCalculateExpenses = () => {
    if (!calculateExpensesFrom || !talentId) return;
    const payload = {
      talentId,
      date: format(calculateExpensesFrom, "yyyy-MM-dd"),
      onlyAccumulations: calculateAccumulationsOnly,
    };
    setAreExpensesCalculated(true);
    dispatch(recalculateExpenses(payload)).then((action) => {
      if (isFulfilled(action)) {
        sendMessage(t("talentProfile:expenseCalculatingStarted"), "success");
      }
      setCalculateExpensesFrom(null);
      setAreExpensesCalculated(false);
    });
  };

  return (
    <Box mb={2}>
      <DesktopDatePicker
        value={calculateExpensesFrom}
        format="dd.MM.yyyy"
        onChange={(value: Date | null) => setCalculateExpensesFrom(value)}
        slotProps={{
          textField: {
            size: "small",
          },
        }}
      />
      <FormControlLabel
        label={t("talentProfile:calculateAccumulationsOnly")}
        control={
          <Checkbox
            checked={calculateAccumulationsOnly}
            onChange={() => {
              setCalculateAccumulationsOnly(!calculateAccumulationsOnly);
            }}
            sx={{ paddingLeft: 2 }}
          />
        }
      />
      <SpinnerButton
        label={t("talentProfile:calculateWages")}
        onClick={handleCalculateExpenses}
        variant="contained"
        isLoading={areExpensesCalculated}
        color="error"
        disabled={!calculateExpensesFrom}
        sx={{
          height: "36px",
          borderRadius: "20px",
        }}
      />
    </Box>
  );
};
